var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 8H16C11.6 8 8.04 11.6 8.04 16L8 88L24 72H80C84.4 72 88 68.4 88 64V16C88 11.6 84.4 8 80 8ZM24 36H72V44H24V36ZM56 56H24V48H56V56ZM72 32H24V24H72V32Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.16b1a373c2440a6519885efef3238978.svg";
export { ForwardRef as ReactComponent };